import { SummaryLine } from '@/components/modules/_shared/components/SummaryLine';
import { ChannelTypeIcons } from '@/components/modules/MerchantDetail/MerchantStructure/constants/ChannelTypeIcons';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { ICON_NAMES } from '@/config/config';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';

interface MerchantAgentCardProps {
  merchantStructure: MerchantStructureEntity;
}

export const MerchantAgentCard = ({ merchantStructure }: MerchantAgentCardProps) => {
  const channel = merchantStructure.getChannelOrFirstChannel();
  const agent = merchantStructure.getAgentOrFirstAgent();

  return (
    <CustomPaper fill="paper">
      <Font variant="h5" color="title">
        <Text strong tId={'SALES_CHANNEL'} />
      </Font>
      <FlexColumn gridGap={4} pt={1} minWidth={0}>
        <FlexRow width="100%" justifyContent="flex-start">
          <Icon size={16}>{ChannelTypeIcons[channel.type]}</Icon>
          <SummaryLine label="CHANNEL" value={channel.description} />
        </FlexRow>
        <FlexRow width="100%" justifyContent="flex-start">
          <Icon size={16}>{ICON_NAMES.AGENT}</Icon>
          <SummaryLine label="AGENT" value={agent.name} />
        </FlexRow>
      </FlexColumn>
    </CustomPaper>
  );
};
